import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const Print = ({ type, ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 24 24' {...rest}>
    {type === 'stroke' ? (
      <path
        d='M9.25 10.75h-2.5m0 3v5.5a2 2 0 0 0 2 2h6.5a2 2 0 0 0 2-2v-5.5m-10.5 0h10.5m-10.5 0v3.5h-2a2 2 0 0 1-2-2v-6.5a2 2 0 0 1 2-2h14.5a2 2 0 0 1 2 2v6.5a2 2 0 0 1-2 2h-2v-3.5m-8.5-11h6.5a2 2 0 0 1 2 2v2H6.75v-2a2 2 0 0 1 2-2'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    ) : (
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M9 2a3 3 0 0 0-3 3v1H5a3 3 0 0 0-3 3v6a3 3 0 0 0 3 3h1v1a3 3 0 0 0 3 3h6a3 3 0 0 0 3-3v-1h1a3 3 0 0 0 3-3V9a3 3 0 0 0-3-3h-1V5a3 3 0 0 0-3-3zm7 4V5a1 1 0 0 0-1-1H9a1 1 0 0 0-1 1v1zm0 9H8v4a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1zM6 11a1 1 0 0 1 1-1h2a1 1 0 1 1 0 2H7a1 1 0 0 1-1-1'
        fill='currentColor'
      />
    )}
  </IconBase>
);
